import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import About from './components/About';
import Destinations from './components/Destinations';
import Properties from './components/Properties';
import Partners from './components/Partners';
import PrivateAccess from './components/PrivateAccess';
import Footer from './components/Footer';
import MandateForm from './components/MandateForm';
import { Toaster } from './components/ui/sonner';

// Home page component
function HomePage() {
  return (
    <>
      <Navigation />
      <Hero />
      <div id="about">
        <About />
      </div>
      <div id="destinations">
        <Destinations />
      </div>
      <Properties />
      <div id="partners">
        <Partners />
      </div>
      <div id="contact">
        <PrivateAccess />
      </div>
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/mandate" element={<MandateForm />} />
        </Routes>
        <Toaster />
      </div>
    </Router>
  );
}

export default App;
